<template>
    <app-layout>
        <common-page-plain>
            <common-content-spacer height="medium" :isCenter="true">
                <common-icon-info :href="'https://docs.google.com/spreadsheets'" target="blanc" size="medium" icon="open-link">
                    {{ $t('pages.administrator.claim_your_profile.claim_your_profile_modal.google_sheets_link') }}
                </common-icon-info>
                <select-input
                    class="CYP-campaign-select"
                    :placeholder="
                        $t('pages.administrator.claim_your_profile.claim_your_profile_modal.select_campaign_placeholder')
                    "
                    :hasAutofocus="true"
                    :options="campaignOptions"
                    :value="selectedCampaign"
                    @change="selectCampaign($event)"
                ></select-input>
                <text-input
                    v-if="!isPCPDisabled"
                    class="CYP-pcp-input"
                    :placeholder="$t('pages.administrator.claim_your_profile.claim_your_profile_modal.pcp_placeholder')"
                    :isRequired="true"
                    @change="changePCP($event)"
                ></text-input>
                <input ref="fileInput" type="file" style="display: none" accept=".xlsx, .xls" @change="fileSelected($event)" />
                <button
                    v-if="!selectedFiles.length"
                    class="referral-notes__upload-btn referral-notes__upload-btn--medium"
                    @click="$refs.fileInput.click()"
                >
                    <common-icon name="cloud" size="gigantic"></common-icon>
                    <span>{{ $t('pages.administrator.claim_your_profile.buttons.upload_xlsx') }}</span>
                </button>
                <common-upload-summary
                    :isUploading="false"
                    :isCenter="true"
                    :files="selectedFiles"
                    @remove-file="removeFile($event)"
                ></common-upload-summary>
                <common-buttons>
                    <common-button
                        :isDisabled="isDisabled"
                        :label="$t('common.microcopy.save')"
                        :isProcessing="isProcessing"
                        type="primary"
                        @click="uploadFile"
                    ></common-button>
                </common-buttons>
                <common-notification ref="commonSuccessNotificationChild" :content="notificationMessage"></common-notification>
                <claim-your-profile-error-modal
                    v-if="showErrorModal"
                    :defaultCloseButtonEnabled="true"
                    :emailErrorList="emailErrorList"
                    :totalEmailsCount="totalEmailsCount"
                    @close="closeErrorModal"
                ></claim-your-profile-error-modal>
            </common-content-spacer>
        </common-page-plain>
    </app-layout>
</template>

<script>
    import AppLayout from 'components/layouts/AppLayout'
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import UploadMixin from 'mixins/UploadMixin'
    import AdministratorAPI from 'api/AdministratorAPI'
    import ClaimYourProfileErrorModal from 'components/page-elements/admin-panel/claim-your-profile/ClaimYourProfileErrorModal'
    import SelectInput from 'components/form-inputs/SelectInput'
    import CYPEnum from 'enums/CYPEnum'
    import TextInput from '../../components/form-inputs/TextInput'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin, UploadMixin],

        components: {
            AppLayout,
            ClaimYourProfileErrorModal,
            SelectInput,
            TextInput,
        },

        data() {
            return {
                notificationMessage: '',
                isProcessing: false,
                emailErrorList: [],
                showErrorModal: false,
                selectedCampaign: null,
                pcp: '',
                campaignOptions: [
                    {
                        label: CYPEnum.GENERAL,
                        value: CYPEnum.GENERAL,
                    },
                    {
                        label: CYPEnum.ACO,
                        value: CYPEnum.ACO,
                    },
                    {
                        label: CYPEnum.CMP,
                        value: CYPEnum.CMP,
                    },
                    {
                        label: CYPEnum.PCP,
                        value: CYPEnum.PCP,
                    },
                ],
            }
        },

        computed: {
            isDisabled() {
                if (this.selectedCampaign === CYPEnum.PCP && this.pcp.length === 0) {
                    return true
                }
                return !this.selectedFiles.length || !this.selectedCampaign
            },
            isPCPDisabled() {
                return this.selectedCampaign !== CYPEnum.PCP
            },
        },

        methods: {
            changePCP(pcp) {
                this.pcp = pcp
            },
            selectCampaign(campaign) {
                this.selectedCampaign = campaign
            },
            fileSelected(event) {
                this.onFileSelected(event)
                this.$refs.fileInput.value = ''
            },

            closeErrorModal() {
                this.showErrorModal = false
            },

            removeFile(event) {
                this.removeAndValidateFiles(event)
            },

            uploadFile() {
                this.isProcessing = true
                this.convertFileToBase64(this.selectedFiles[0]).then((value) => {
                    AdministratorAPI.uploadCsv(value, this.selectedCampaign, this.pcp)
                        .then((response) => {
                            this.$refs.fileInput.value = ''
                            this.selectedFiles = []
                            this.totalEmailsCount = response.updatedEmails.length + response.invalidEmails.length
                            if (!response?.invalidEmails?.length) {
                                this.notificationMessage = this.$t(
                                    'pages.administrator.claim_your_profile.buttons.csv_upload_success',
                                )
                                this.$refs.commonSuccessNotificationChild.showNotification()
                                return
                            }
                            this.emailErrorList = response?.invalidEmails
                            this.showErrorModal = true
                        })
                        .finally(() => ((this.isProcessing = false), (this.selectedCampaign = null)))
                })
            },
        },
    }
</script>
<style scoped>
    .CYP-campaign-select {
        width: 240px;
    }
    .CYP-pcp-input {
        width: 240px;
    }
</style>
